/* file description */
import React from 'react';
import { PageType } from '../types';
import AssetTaskForm from './AssetTaskTem';
import { AssetTaskTable } from '../AssetTaskTable';
import _ from 'lodash';

export function AssetTaskTem(props: any) {
  const pageConfig = props.pageConfig && _.cloneDeep(props.pageConfig);
  if (props.pageType === PageType.List) {
    return (
      <div>
        <AssetTaskTable {...props} pageConfig={pageConfig} />
      </div>
    );
  }
  return <AssetTaskForm {...props} pageConfig={pageConfig} />;
}
